import type { ReactNode } from 'react';

// Shared section/panel card. Mirrors the demo's `.panel`: surface bg, 18px radius,
// 1px line border, soft shadow, generous padding, navy/gold heading + ink-500 sub.
// Used across Dashboard sections, Settings panels, and any other surface that wants
// the same visual fingerprint.
export function Panel({
  title,
  sub,
  action,
  children,
  className = '',
}: {
  title?: string;
  sub?: string;
  action?: ReactNode; // optional right-aligned slot in the header (e.g. "Edit" link)
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={`rounded-2xl bg-surface border border-line shadow-xs p-5 md:p-6 ${className}`}
    >
      {(title || action) && (
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="min-w-0">
            {title && (
              <h2 className="font-bold text-[17px] text-navy-900 dark:text-gold-500 -tracking-[0.005em]">
                {title}
              </h2>
            )}
            {sub && <p className="text-[13.5px] text-ink-500 mt-1">{sub}</p>}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
